<script>
import {provide, ref} from "vue";
import {useConfig} from "@/helpers/config-effect";
import {Node} from "@/models/node";
import {useStore} from "@/helpers/store-effect";

export default {
  name: 'VariableFinder',
  template: '#variable-finder-template',
  props: {
    workflow: {type: Object, required: true},
  },
  setup(props) {
    const visible = ref(false);
    const search = ref('');
    const searchInput = ref(null);
    const config = useConfig();
    const store = useStore();

    let inputTriggeredBy;
    let currentNode = null;
    let currentlyUsedOutputs = [];

    const show = (fromNode, fromInput, single = false) => {
      visible.value = true;
      currentNode = fromNode;
      fromInput.single = single;
      inputTriggeredBy = fromInput;
      currentlyUsedOutputs = fromInput.value ? fromInput.value.match(/(\{.*?\})/g)?.map(match => match.replace('{', '').replace('}', '')) || [] : [];

      setTimeout(() => searchInput.value.focus(), 100);
    }

    const hide = () => {
      visible.value = false;
      inputTriggeredBy?.focus();
      inputTriggeredBy = null;
      currentlyUsedOutputs = [];
    }

    const isOutputUsed = (output) => {
      return currentlyUsedOutputs.indexOf(output.path) !== -1;
    };

    const useOutput = (node, output) => {
      if (inputTriggeredBy.single) {
        inputTriggeredBy.value = output.ref;
      } else {
        inputTriggeredBy.value += (inputTriggeredBy.value.length && !inputTriggeredBy.value.endsWith(' ') ? ' ' : '') + output.ref;
      }
      inputTriggeredBy.dispatchEvent(new Event('input'));
      hide();
    }

    const outputFilter = (output) => output.name
        .concat(' ', output.id).toLocaleLowerCase()
        .concat(' ', output.subOutputs?.map(subOutput => subOutput.name.concat(' ', output.id).toLocaleLowerCase()) || '')
        .includes(search.value.toLocaleLowerCase());

    const nodeFilter = (node) => {
      return node.outputs.filter(outputFilter).length;
    };

    const getAvailableNodes = () => {
      let nodes = [new Node({
        type: 'global',
        properties: {
          name: ''
        },
        _workflow: store.workflow
      })];

      let node = currentNode;
      while (node.parentNode) {
        node = node.parentNode || false;
        node && nodes.push(node);
      }

      return search.value ? nodes.reverse().filter(nodeFilter) : nodes.reverse();
    };

    provide('isOutputUsed', isOutputUsed);
    provide('outputFilter', outputFilter);

    return {
      search,
      outputFilter,
      get nodes() {
        return getAvailableNodes();
      },
      visible,
      show,
      hide,
      useOutput,
      searchInput,
    }
  },
  mounted() {
    this.$root.variableFinder = this;
  }
}
</script>
